export default {
  styleOverrides: {
    root: {
      borderRadius: '8px',
      padding: '12px 16px',
    },

    standardSuccess: {
      backgroundColor: 'var(--color-success-light)',
      color: 'var(--color-success-dark)',

      '& .MuiAlert-icon': {
        color: 'var(--color-success)',
      },
    },

    standardError: {
      backgroundColor: 'var(--color-error-light)',
      color: 'var(--color-error-dark)',

      '& .MuiAlert-icon': {
        color: 'var(--color-error)',
      },
    },

    standardWarning: {
      backgroundColor: 'var(--color-warning-light)',
      color: 'var(--color-warning-dark)',

      '& .MuiAlert-icon': {
        color: 'var(--color-warning)',
      },
    },

    standardInfo: {
      backgroundColor: 'var(--color-info-light)',
      color: 'var(--color-info-dark)',

      '& .MuiAlert-icon': {
        color: 'var(--color-info)',
      },
    },

    filledSuccess: {
      backgroundColor: 'var(--color-success)',
      color: 'var(--color-success-contrast)',
    },

    filledError: {
      backgroundColor: 'var(--color-error)',
      color: 'var(--color-error-contrast)',
    },

    filledWarning: {
      backgroundColor: 'var(--color-warning)',
      color: 'var(--color-warning-contrast)',
    },

    filledInfo: {
      backgroundColor: 'var(--color-info)',
      color: 'var(--color-info-contrast)',
    },

    outlinedSuccess: {
      borderColor: 'var(--color-success)',
      color: 'var(--color-success-dark)',

      '& .MuiAlert-icon': {
        color: 'var(--color-success)',
      },
    },

    outlinedError: {
      borderColor: 'var(--color-error)',
      color: 'var(--color-error-dark)',

      '& .MuiAlert-icon': {
        color: 'var(--color-error)',
      },
    },

    outlinedWarning: {
      borderColor: 'var(--color-warning)',
      color: 'var(--color-warning-dark)',

      '& .MuiAlert-icon': {
        color: 'var(--color-warning)',
      },
    },

    outlinedInfo: {
      borderColor: 'var(--color-info)',
      color: 'var(--color-info-dark)',

      '& .MuiAlert-icon': {
        color: 'var(--color-info)',
      },
    },
  },
};
